import { Modal } from "bootstrap";

export function show(idModal) {
  let modal = new Modal(document.getElementById(idModal));
  modal.show();
}
